import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { kirksvilleMOConfig } from "./data";

export default function KirksvilleMOPage() {
  return <CityPageTemplate config={kirksvilleMOConfig} />;
}